<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/87/title-bg.png" alt="" />
      <div class="technological-process">
        <div class="zcjj">
          <img class="top" style="height: 2.12rem" src="./../assets/imgs/84/zcjj.png" alt="" />
          <div class="content">
            <div class="des">
              为进一步激发我县社治领域人才活力，面向全县挖掘社区（含建制村，下同）各类能人，特别是具有示范带头作用的优秀社区导游、社区讲师、社区调解能手、社区才艺师、社区营造师、社区规划师等群体作为全县社治领域重点扶持培育对象，每年评选认定一次，每次评选认定20名，助推我县城乡社区发展治理水平提升。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="./../assets/imgs/84/title-1.png" alt="" />
          <div class="content">
            在我县的社区居民以及长期扎根我县社区参与社区发展治理工作的人员（在编机关事业单位工作人员除外）。
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="./../assets/imgs/84/title-2.png" alt="" />
          <div class="content">
            申报人选具体条件，详见政策文件。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/84/title-3.png" alt="" />
          <div class="content">
            <div class="des" style="textAlign:center">
              <div class="title">一. 资金支持</div>
              享受每人一次性奖励1万元。
            </div>
            <div class="des">
              <div class="title">二. 其他</div>
              在推荐申报国家、省、市、县各级人才评审项目时予以优先考虑。
            </div>

          </div>
        </div>
        <div class="sbcl">
          <img class="top" src="./../assets/imgs/84/title-4.png" alt="" />
          <div class="content">
            <div class="des">
              <div class="item">
                <div class="line"></div>
                <div class="dot">1</div>
                印发申报通知
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">2</div>
                申报
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">3</div>
                各镇（街道）初审
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">4</div>
                县委社治委复审
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">5</div>
                评审工作小组综合评审
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">6</div>
                县社治工作领导小组审批
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">7</div>
                县委人才工作领导小组审定
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">8</div>
                公示
              </div>
              <div class="item">
                <div class="dot">9</div>
                确定人选
              </div>
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="./../assets/imgs/84/title-5.png" alt="" />
          <div class="content" style="fontWeight:bold;fontSize:0.3rem">
            依据每年通知时间确定
          </div>
        </div>
        <div class="contact">
          <img class="top" src="./../assets/imgs/84/title-6.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-88311380">028-88311380</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              县委社治委
            </div>
          </div>
        </div>
        <div class="codes">
          <img class="code" src="../assets/imgs/87/code.png" />
          <img class="text" src="../assets/imgs/85/text.png" />
        </div>
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() { },

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 4.73rem;
  }

  .technological-process {
    transform: translateY(-2rem);

    .zcjj {

      // background-color:#fff;
      .top {
        width: 6.68rem;
        height: 2.12rem;
      }

      .content {
        width: 6.68rem;
        background: #ffffff;
        margin: -0.45rem auto 0;
        padding: 0.1rem 0.33rem 0.46rem 0.36rem;
        box-sizing: border-box;
        line-height: 0.44rem;

        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .title {
          font-size: 0.34rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          font-size: 0.26rem;
          color: #4e4e4e;
          text-align: left;
          margin-top: 0.16rem;
          line-height: 0.44rem;
        }
      }
    }

    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;

        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #E8EEFF;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;

        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.8rem;
          position: relative;
          text-align: left;
          line-height: 0.44rem;

          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 2.98rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .sbcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.34rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.1rem 0.23rem 0.3rem;
          position: relative;

          .item {
            margin-top: 0.35rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            color: #3D5AA3;
            font-size: 0.32rem;
            font-weight: bold;
            line-height: 0.46rem;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 135%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.1rem;
              top: 0.2rem;
              z-index: 0;

              //   background-color: #739bfe;
            }

            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;

              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .code {
        width: 1.94rem;
        height: 1.94rem;
      }

      .text {
        height: 1.2rem;
      }
    }
  }
}</style>
